import { CheckoutState } from '../../state';
import { getNamespaceValue } from '../utils/selector';

export const areExpressCheckoutConditionsLoaded = (state: CheckoutState) =>
    !!getNamespaceValue(state.expressCheckout, 'expressCheckoutConditions');

export const hasCannedQuestions = (state: CheckoutState) =>
    getNamespaceValue(
        state.expressCheckout,
        'expressCheckoutConditions.hasCannedQuestions',
        true,
    );

export const hasCustomQuestions = (state: CheckoutState) =>
    getNamespaceValue(
        state.expressCheckout,
        'expressCheckoutConditions.hasCustomQuestions',
        true,
    );

export const hasPrepaymentQuestions = (state: CheckoutState) =>
    getNamespaceValue(
        state.expressCheckout,
        'expressCheckoutConditions.hasPrepaymentQuestions',
        true,
    );

export const isApplePayAvailableAsExpressPaymentMethod = (
    state: CheckoutState,
) =>
    getNamespaceValue(
        state.expressCheckout,
        'expressCheckoutConditions.hasApplePay',
        false,
    );

export const isGooglePayAvailableAsExpressPaymentMethod = (
    state: CheckoutState,
) =>
    getNamespaceValue(
        state.expressCheckout,
        'expressCheckoutConditions.hasGooglePay',
        false,
    );

export const isPaypalAvailableAsExpressPaymentMethod = (state: CheckoutState) =>
    getNamespaceValue(
        state.expressCheckout,
        'expressCheckoutConditions.hasPaypal',
        false,
    );

export const hasRequiredCustomQuestions = (state: CheckoutState) =>
    getNamespaceValue(
        state.expressCheckout,
        'expressCheckoutConditions.hasRequiredCustomQuestions',
        true,
    );

export const hasRequiredCannedQuestions = (state: CheckoutState) =>
    getNamespaceValue(
        state.expressCheckout,
        'expressCheckoutConditions.hasRequiredCannedQuestions',
        true,
    );
